import { IUserProfileUnit, UserProfileUnit } from './UserProfileUnit';

/**
 * User Profile object to store selected values
 */
export interface IUserProfile {
    /** Id given from dexidb table */
    id?: number;
    /** id of the user to identifi */
    userId: string;
    /** name of the user to identifi */
    userName?: string;
    /** email of the user to identifi */
    userEmail?: string;
    /** value sof selected units, see {@link IUserProfileUnit} */
    units: IUserProfileUnit[];
}

export class UserProfile implements IUserProfile {
    public id?: number;
    public userId: string;
    public userName?: string;
    public userEmail?: string;
    public units: IUserProfileUnit[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IUserProfile);
    constructor(obj?: any) {
        // do not set id to undefined or dexie.js will throw an error
        if (obj && obj.id != null) {
            this.id = obj.id;
        }

        this.userId = obj && obj.userId || '';
        this.userName = obj && obj.userName || undefined;
        this.userEmail = obj && obj.userEmail || undefined;
        this.units = [];
        if (obj && obj.units) {
            obj.units.forEach((unit: IUserProfileUnit) => {
                this.units.push(new UserProfileUnit(unit));
            });
        }
    }
}
